import { useLazyQuery } from '@apollo/client'
import { GET_USER_DATA } from 'apollo/queries/user'
import type {
  UserDataQueryQuery,
  UserDataQueryQueryVariables,
} from 'apollo/graphql.types'

const useUserClients = ({
  handleCompleted,
}: {
  handleCompleted: (info: UserDataQueryQuery) => void
}) => {
  const [loadUserData, { called, loading, error }] = useLazyQuery<
    UserDataQueryQuery,
    UserDataQueryQueryVariables
  >(GET_USER_DATA, {
    variables: { withClient: true },
    fetchPolicy: 'cache-and-network',
    onCompleted: handleCompleted,
  })

  return { loadUserData, called, loading, error }
}

export default useUserClients
